import React from "react";
import SEOLandingPage from "./SEOLandingPage";

const CsvViewerAndroid: React.FC = () => (
  <SEOLandingPage
    title="CSV Viewer for Android — Open & Edit CSV Files on Your Phone | Cosmovex"
    metaDescription="CSV Viewer & Editor for Android. Open, edit, and manage CSV files with spreadsheet-style grid view. Sort, filter, and export data directly from your phone."
    ogTitle="CSV Viewer & Editor for Android"
    h1="CSV Viewer & Editor for Android"
    intro="View, edit, and analyze CSV files directly on your phone with a clean spreadsheet-style interface. Sort, filter, edit cells, and export data without a laptop."
    paragraphs={[
      "CSV files are everywhere — survey data, contact lists, financial exports, inventory sheets. But viewing and editing them on mobile usually means struggling with text editors or dealing with incompatible mobile spreadsheet apps. CSV Viewer & Editor changes that by giving you a proper spreadsheet interface optimized for mobile.",
      "Open any CSV file from your device storage or clipboard. Instantly see your data in a clean, scrollable grid with a frozen header row. Tap any column to sort ascending or descending. Use the search bar to filter rows in real-time. Edit individual cells with a single tap. Add new rows, delete rows, rename columns — all with intuitive mobile-friendly controls.",
      "The app handles real-world CSV complexity. It parses comma, semicolon, tab, and pipe delimiters. It correctly handles quoted fields, embedded delimiters, and multi-line values — the kinds of edge cases that break basic CSV readers. Column statistics let you see count, sum, min, max, and average for numeric columns without opening a calculator.",
      "Everything is saved locally on your device. When you're done, export your changes back to CSV or share your data directly with other apps. Perfect for business users, data analysts, researchers, and anyone who needs to manage CSV data on the go.",
    ]}
    features={[
      "Spreadsheet grid view with frozen headers",
      "Sort and filter rows instantly",
      "Edit cells, add/delete rows and columns",
      "Smart CSV parser — handles edge cases",
      "Column statistics (count, sum, min, max, avg)",
      "Works with comma, semicolon, tab, pipe delimiters",
      "Export to CSV or share directly",
      "Open from storage or clipboard",
      "Works offline completely",
      "Dark theme for comfortable viewing",
    ]}
    playStoreUrl="https://play.google.com/store/apps/details?id=com.cosmovex.csvvedit"
    icon="/images/csvvedit.png"
    appName="CSV Viewer & Editor"
    accentColor="#A8720E"
    canonicalPath="/csv-viewer-android"
  />
);

export default CsvViewerAndroid;
